// 后端返回的错误码
export const ERROR_CODE = [
    'ERROR_18005',
    'ERROR_8010',
    'ERROR_8011',
    'ERROR_15008',
    'ERROR_15009',
    'ERROR_8009',
    'ERROR_18008',
    'ERROR_6043',
    'ERROR_6041',
    'ERROR_6042',
    'ERROR_8000',
    'ERROR_8002',
    'ERROR_8003',
    'ERROR_8004',
    'ERROR_16010',
    'ERROR_66011',
    'ERROR_66031',
    'ERROR_66040',
    'ERROR_66018',
    'ERROR_66020',
    'ERROR_66021',
    'ERROR_66028',
    'ERROR_66006',
    'ERROR_66002',
    'ERROR_5010',
    'ERROR_20022',
    'ERROR_12076',
    'ERROR_20013',
    'ERROR_20024',
    'ERROR_20002',
    'ERROR_20003',
    'ERROR_20004',
    'ERROR_20005',
    'ERROR_12006',
    'ERROR_20007',
    'ERROR_4004',
    'ERROR_4005',
    'ERROR_4006',
    'ERROR_4007',
    'ERROR_16057',
    'ERROR_16058',
    'ERROR_16059',
    'ERROR_8014',
    'ERROR_8015',
    'ERROR_6060',
    'ERROR_16061',
    'ERROR_16062',
    'ERROR_6063',
    'ERROR_16064',
    'ERROR_6067',
    'ERROR_8016',
    'ERROR_16039',
    'ERROR_18018',
    'ERROR_10002',
    'ERROR_111',
    'ERROR_6069',
    'ERROR_6046',
    'ERROR_20008',
    'ERROR_20009',
    'ERROR_8022',
    'ERROR_10004',
    'ERROR_10011',
    'ERROR_18023',
    'ERROR_18024',
    'ERROR_18025',
    'ERROR_6038',
    'ERROR_16007',
    'ERROR_16009',
    'ERROR_16008',
    'ERROR_16003',
    'ERROR_16005',
    'ERROR_16004',
    'ERROR_5006',
    'ERROR_10003',

    'ERROR_60003',
    'ERROR_60004',
    'ERROR_60005',
    'ERROR_60007',
    'ERROR_60008',
    'ERROR_60012',
    'ERROR_60015',
    'ERROR_60016',
    'ERROR_66019',
    'ERROR_66013',
    'ERROR_66014',
    'ERROR_10001',
    'ERROR_10005',
    'ERROR_10009',
    'ERROR_10010',
    'ERROR_10012',
    'ERROR_10013',
    'ERROR_10016',
    'ERROR_10017',
    'ERROR_10018',
    'ERROR_10019',
    'ERROR_10020',
    'ERROR_10021',
    'ERROR_10022',
    'ERROR_10023',
    'ERROR_16006',
    'ERROR_16048',
    'ERROR_16052',
    'ERROR_18013',
    'ERROR_10024',
    'ERROR_10025',
    'ERROR_60028',
    'ERROR_12022',
    'ERROR_18026',
    'ERROR_60038',
    'ERROR_15010',
    'ERROR_96036',
    'ERROR_18041',
    'ERROR_1107',
    'ERROR_50106',
    'ERROR_10045',
    'ERROR_16065',
    'ERROR_50102',
    'ERROR_10089',
    'ERROR_60044',
    'ERROR_10090',
    'ERROR_8201',
    'ERROR_50111',
    'ERROR_60024',
    'ERROR_10097',
    'ERROR_8026',
    'ERROR_8027',
    'ERROR_10100',
    'ERROR_10101',
    'ERROR_60046',
]

//是否刷新图像验证码
export const ImageVerifyCode = (() => {
    const code = [ 'ERROR_18005', 'ERROR_10009', 'ERROR_12006', 'ERROR_10005', 'ERROR_15008', 'ERROR_10006', 'ERROR_10025' ]
    const check = (errorCode) => {
        return code.indexOf(errorCode) != -1
    }
    return {
        check,
    }
})()

export const PopupDialog = [ 'ERROR_18005', 'ERROR_8010', 'ERROR_8011', 'ERROR_15008', 'ERROR_15009', 'ERROR_8009' ]
